import { SxProps, Theme } from '@mui/material';
import React from 'react';

import { TradeEnum } from '_lib/api/apiTypes.shim';

import { MenuItem } from '_lib/components/MenuItem/MenuItem';
import { TextField } from '_lib/components/TextField/TextField';
import { Typography } from '_lib/components/Typography/Typography';
import { FieldIssueProps } from '_lib/utils/validationErrorUtils';

export interface TradeSelectProps extends FieldIssueProps {
  onSetTrade: (Trade: TradeEnum) => void;
  trade: TradeEnum | null;
  trades: TradeEnum[];
  disabled?: boolean;
  sx?: SxProps<Theme>;
}

export const TradeSelect = (props: TradeSelectProps) => {
  const { onSetTrade, trade, trades, issuePath, issues, disabled, sx } = props;

  return (
    <TextField
      fullWidth
      label='Trade'
      required
      disabled={disabled || trades.length === 1}
      value={trade || ''}
      defaultValue={''}
      select
      sx={sx}
      error={{ issuePath, issues }}
      onChange={(e) => {
        if (e.target.value) {
          const value = parseInt(e.target.value);
          if (!isNaN(value)) onSetTrade(value);
        }
      }}>
      {trades.map((trade: TradeEnum) => (
        <MenuItem key={trade} value={trade}>
          <Typography text={TradeEnum[trade]} />
        </MenuItem>
      ))}
    </TextField>
  );
};
